import { RS_TURBO_DOUBLE_CHANCE } from "@/resources/data/doubleChange/turbo";
import { RS_CHANGE_DOUBLE_CHANCE } from "@/resources/data/doubleChange/chance";
import {
  RS_EXTRA6_DOUBLE_CHANCE,
  RS_EXTRA7_DOUBLE_CHANCE,
} from "@/resources/data/doubleChange/extra";
import {
  RS_TURBO_2,
  RS_TURBO_3,
  RS_TURBO_4,
  RS_TURBO_5,
} from "@/resources/data/turbo/turbo";
import {
  RS_CHANCE_2,
  RS_CHANCE_3,
  RS_CHANCE_4,
  RS_CHANCE_5,
} from "@/resources/data/chance/chance";
import {
  RS_CHANCE_PLUS_3,
  RS_CHANCE_PLUS_4,
  RS_CHANCE_PLUS_5,
} from "@/resources/data/chance/chancePlus";

export const RS_DOUBLE_CHANCE = [
  RS_CHANGE_DOUBLE_CHANCE,
  RS_TURBO_DOUBLE_CHANCE,
  RS_EXTRA6_DOUBLE_CHANCE,
  RS_EXTRA7_DOUBLE_CHANCE,
];

export const RS_DATA_TURBO = [RS_TURBO_2, RS_TURBO_3, RS_TURBO_4, RS_TURBO_5];

export const RS_DATA_CHANCE = [
  RS_CHANCE_2,
  RS_CHANCE_3,
  RS_CHANCE_4,
  RS_CHANCE_5,
];

export const RS_DATA_CHANCE_PLUS = [
  RS_CHANCE_PLUS_3,
  RS_CHANCE_PLUS_4,
  RS_CHANCE_PLUS_5,
];
